let baseUrl = '';

if (process.env.NODE_ENV === 'development') {
  baseUrl = `http://localhost:7802`; // 开发环境
} else {
  if (process.env.VUE_APP_TITLE === 'test') {
    baseUrl = `https://sd-api-test.ycstc.com.cn`; // 测试环境(暂未配置域名)
  } else if (process.env.VUE_APP_TITLE === 'dev') {
    baseUrl = `https://sd-api-dev.ycstc.com.cn`; // 开发环境(暂未配置域名)
  } else {
    baseUrl = `https://sd-api.ycstc.com.cn`; // 生产环境
  }
}

const ENVIRONMENT = {
  BASE_API: baseUrl // api访问地址
};

export default ENVIRONMENT;
